import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';

export interface FilterProps {
  allOption?: boolean;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  label: string;
  onChange: (value: string) => void;
  options: Array<SelectOption>;
  selectedValue: string;
  size?: 'small' | 'medium';
  testId?: string;
}

export const Filter = ({
  allOption = true,
  className = '',
  containerClassName = '',
  disabled = false,
  label,
  onChange,
  options,
  selectedValue,
  size = 'small',
  testId = 'filter'
}: FilterProps) => {
  const handleSelectOption = (newValue: SelectOption) => {
    const { value } = newValue;

    onChange(value);
  };

  return (
    <Select
      allOption={allOption}
      className={className}
      containerClassName={containerClassName}
      disabled={disabled}
      onChange={handleSelectOption}
      label={label}
      options={options}
      size={size}
      testId={testId}
      value={selectedValue}
    />
  );
};
